import type { TherapistUpdateQuery } from "@/Modules/Models/Domain/Therapist";
import type { TherapistUpdateApiQuery } from "@/Modules/Models/Api/Therapist";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import useTherapistStore from "../Store";
import useAppStore from "@/Modules/App/Store";

import TherapistApiConnector from "@/Services/TherapyApi/Therapists";

import TherapistApiToTherapistTransformer from "@/Modules/Transformers/Therapist/TherapistApiToTherapist";

const updateTherapistActionHandler = async (therapistUpdateQuery: TherapistUpdateQuery): Promise<boolean> => {
  const therapistApiConnector = new TherapistApiConnector();
  const therapistApiToTherapistTransformer = new TherapistApiToTherapistTransformer();
  const therapistStore = useTherapistStore();
  const appStore = useAppStore();

  try {
    therapistStore.isLoading = true;

    const therapistUpdateApiQuery: TherapistUpdateApiQuery =
      transformTherapistUpdateQueryToTherapistUpdateApiQuery(therapistUpdateQuery);

    const therapistApi = await therapistApiConnector.update(therapistUpdateApiQuery);

    therapistStore.therapist = therapistApiToTherapistTransformer.transform(therapistApi);
    therapistStore.isLoading = false;

    appStore.showSnackbar({
      message: "account.your_preferences_change",
      type: NotificationType.SUCCESS,
    });

    return true;
  } catch (error: unknown) {
    // not handled error
    therapistStore.isLoading = false;

    return false;
  }
};

const transformTherapistUpdateQueryToTherapistUpdateApiQuery = (
  therapistUpdateQuery: TherapistUpdateQuery
): TherapistUpdateApiQuery => {
  let areas;

  if (therapistUpdateQuery.areas) {
    areas = therapistUpdateQuery.areas.map((area) => {
      return {
        area_i18n: area.areaI18n,
        area_id: area.areaId,
        area: area.areaI18n,
        country: area.country,
        is_active: area.isActive,
        sub_area_i18n: area.subAreaI18n,
        sub_area_id: area.subAreaId,
        sub_area: area.subAreaI18n,
      };
    });
  }

  const therapistUpdateApiQuery: TherapistUpdateApiQuery = {
    ccc: therapistUpdateQuery.iban,
    capacity_morning: therapistUpdateQuery.capacityMorning,
    capacity_afternoon: therapistUpdateQuery.capacityAfternoon,
    availability_id: therapistUpdateQuery.availabilityId,
    fast_assignment: therapistUpdateQuery.fastAssignment,
    areas,
    min_price_per_session: therapistUpdateQuery.minPricePerSession,
  };

  return therapistUpdateApiQuery;
};

export default updateTherapistActionHandler;
